import { IInference, IAstNode } from './typings';
import { TypeGenerator } from '../utils/type';
import { isDigit, isNumber } from '../utils/type';
import { InferenceError } from '../errors';



export function inferenceArithmeticNode(inference: IInference, astNode: IAstNode) {
  const leftType = inference(astNode.left)!;
  const rightType = inference(astNode.right)!;

  if (!isDigit(leftType, false)) {
    throw new InferenceError('arithmetic-type-error', '非数字类型不能参与计算', astNode.token.position);
  }
  if (!isDigit(rightType, false)) {
    throw new InferenceError('arithmetic-type-error', '非数字类型不能参与计算', astNode.token.position);
  }

  if ('/%'.includes(astNode.operator) &&
    astNode.right.type === 'Atom' &&
    astNode.right.token &&
    astNode.right.token.type === 'Integer' &&
    astNode.right.token.value === 0) {
    throw new InferenceError('arithmetic-value-error', '0 不能作为除数', astNode.token.position);
  }


  if ('+-*%'.includes(astNode.operator)) {
    return (isNumber(leftType, false) || isNumber(rightType, false)) ?
      TypeGenerator.Number() :
      TypeGenerator.Integer();
  } else {
    return TypeGenerator.Number();
  }
}
